export default {
  setEntries (state, entries) {
    state.entries = entries
  },

  setAllowed (state, allowed) {
    state.entry.allowed = allowed
  }
}
